import { GatsbyImage } from 'gatsby-plugin-image';

import Eyebrow from '@klv/atoms/eyebrow';
import Buttons from '@klv/molecules/buttons';
import styled from 'styled-components';


export const StyledEyebrow = styled(Eyebrow)<{ $backgroundColor: string; }>`
${({ theme }) => (`
  color: ${theme.colors.white};
`)};
`;

export const StyledButtons = styled(Buttons)`
  justify-content: center;
`;

export const Poster = styled(GatsbyImage)``;
